import axios from 'axios'
import config from '../../config'

const baseUrl = `${config.backend}node/`

export const getUniqueTypes = async () => {
    const response = await axios.get(baseUrl + 'unique')
    return response.data
}

export const addType = async (data, type) => {
    const response = await axios.post(baseUrl + type, data)
    return response.data
}

export const addChild = async (data, typeId, type) => {
    const response = await axios.post(`${baseUrl + type}/${typeId}/child`, data)
    return response.data
}

export const deleteSingleType = async (data, typeId, type) => {
    const response = await axios.post(`${baseUrl + type}/${typeId}`, data)
    return response.data
}

export const getForAllLocales = async (type) => {
    const response = await axios.get(baseUrl + `all/${type}`)
    return response.data
}

export const updateType = async (data, typeId, type) => {
    const response = await axios.put(`${baseUrl + type}/${typeId}`, data)
    return response.data
}